<template>
  <div class="main" style="background: white">
    <div class="logo">
      <img :src="logo">
    </div>
    <div class="item">
      <label>
        <span class="title">{{title.name}}</span>
      </label>
      <div style="display: flex">
        <input v-model="user.name" type="text" :class="myClass.name" v-on:blur="checkName" style="width: 100%"/>
      </div>
      <label v-if="checkEmpty.name.value">
        <span class="error_tip">请填写正确的用户名</span>
      </label>
    </div>
    <div class="item">
      <label>
        <span class="title">{{title.psw}}</span>
      </label>
      <div style="display: flex">
        <input v-model="user.password" type="password" :class="myClass.psw" v-on:blur="checkPsw" style="width: 100%"/>
      </div>
      <label v-if="checkEmpty.psw.value">
        <span class="error_tip">请填写密码</span>
      </label>
    </div>
    <div class="item">
      <label>
        <span class="title">{{title.captcha}}</span>
      </label>
      <div style="display: flex">
        <input v-model="captcha.value" type="text" :class="myClass.captcha" v-on:blur="checkCaptcha" style="width: 100%"/>
      </div>
      <label v-if="checkEmpty.captcha.value">
        <span class="error_tip">请填验证码</span>
      </label>
      <div style="margin-top: 10px">
        <img v-bind:src="captcha.url" v-on:click="getCaptcha()" style="cursor: pointer;" >
      </div>
    </div>
    <div class="login content_margin content_pay_item login_btn" @click="submit">
      <span>{{title.submit}}</span>
    </div>
  </div>
</template>

<script>
import {getCaptcha, login} from '@/api'
import logo from '@/assets/gofun_logo.jpg'
export default {
  name: 'Login',
  data () {
    return {
      user: {
        name: null,
        password: null
      },
      captcha: {
        key: null,
        value: null,
        url: null
      },
      title: {
        name: '用户名',
        psw: '密码',
        submit: '登录',
        captcha: '验证码'
      },
      myClass: {
        name: 'input_noerror',
        psw: 'input_noerror',
        captcha: 'input_noerror'
      },
      // 提示控制
      checkEmpty: {
        name: {value: false, message: '请填写用户名'},
        psw: {value: false, message: '请填写密码'},
        captcha: {value: false, message: '请填写验证码'}
      },
      logo: logo
    }
  },
  methods: {
    async submit () {
      let params = {
        user: this.user,
        captcha: this.captcha
      }
      let isLogin = await login(params).then(res => {
        let code = res.data.code
        let data = res.data.data
        let msg = res.data.msg
        console.log('res', res)
        if (code === '200') {
          let myuser = data.user
          let userToken = myuser.api_token
          this.$cookies.set('token', userToken)
          this.$cookies.set('name', myuser.name)
        } else {
          alert(msg)
        }
        return code === '200'
      })
      if (isLogin) {
        console.log('登录成功')
        this.$router.push({name: 'stepone'})
      } else {
        console.log('请重新登录')
      }
    },
    checkData (event, type) {
      let value = event.target.value
      type.value = value === null || value.trim() === ''
    },
    getCaptcha () {
      getCaptcha().then(res => {
        let data = res.data.data
        console.log(res.data)
        this.captcha.url = data.captcha.img
        this.captcha.key = data.captcha.key
      })
    },
    checkName (event) {
      this.checkData(event, this.checkEmpty.name)
    },
    checkPsw (event) {
      this.checkData(event, this.checkEmpty.psw)
    },
    checkCaptcha (event) {
      this.checkData(event, this.checkEmpty.captcha)
    },
    checkParams () {
    }
  },
  mounted () {
    this.getCaptcha()
  }
}
</script>
<style scoped>
  .logo {
    display: flex;
    justify-content: center;
    zoom: 0.5;
    margin-top: 100px;
  }
  .main{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    background: rgb(230,231,231);
    background-size: cover;
    border-radius: 6px;
    height: 1000px;
  }
  input{
    margin-top: 10px;
    width: 600px;
    padding: 8px;
  }
  .item {
    width: 40%;
    margin-top: 60px;
  }
  .login {
    margin-top: 100px;
    font-size: 1.2em;
    padding: 6px;
  }
  .login_btn {
    margin-bottom: 20px;
    width: 40%;
    padding: 8px;
    color: white;
    margin-right: 0;
  }
  .title {
    font-size: 1.2em;
  }
  .error_tip{
    color: red;
  }
  .input_error{
    border: 1px solid red;
  }
  .input_noerror{
    border: 1px solid grey; /*no*/
  }
  @media only screen and (max-width: 400px) {
    .item {
      width: 60%;
      margin-top: 60px;
    }
    .login_btn {
      margin-bottom: 20px;
      width: 60%;
      padding: 8px;
      color: white;
      margin-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue